<div class="filter-profile">
  <div class="profile-grid">
    <div class="profile-row">
      <div class="label">Filter Profile Name</div>
      <div class="value">
        {{ filterProfile?.filterProfileName }}
      </div>
    </div>
    <div class="profile-row" *ngFor="let filter of filters">
      <!-- display the filter's name (object name property) -->
      <div class="label">{{ formatFilterName(filter) | translate }}</div>
      <!-- display the filter's value -->
      <div class="value">

        <!-- set filter -->
        <ng-container *ngIf="filterModel[filter]?.filterType === 'set'">
          <ul class="value-list">
            <li *ngFor="let value of filterModel[filter]?.values.sort()">
              {{ value }}
            </li>
          </ul>
        </ng-container>

        <!-- date filter -->
        <ng-container *ngIf="filterModel[filter]?.filterType === 'date'">
          <ng-container [ngSwitch]="filterModel[filter]?.type">
            <ng-container *ngSwitchCase="'equals'">
              Equals: {{ filterModel[filter].dateFrom | date: 'MM/dd/yyyy' }}
            </ng-container>
            <ng-container *ngSwitchCase="'greaterThan'">
              Greater than: {{ filterModel[filter].dateFrom | date: 'MM/dd/yyyy' }}
            </ng-container>
            <ng-container *ngSwitchCase="'lessThan'">
              Less than: {{ filterModel[filter].dateFrom | date: 'MM/dd/yyyy' }}
            </ng-container>
            <ng-container *ngSwitchCase="'notEqual'">
              Not equal: {{ filterModel[filter].dateFrom | date: 'MM/dd/yyyy' }}
            </ng-container>
            <ng-container *ngSwitchCase="'inRange'">
              In range: <br />{{ filterModel[filter].dateFrom | date: 'MM/dd/yyyy' }} - {{ filterModel[filter].dateTo | date: 'MM/dd/yyyy' }}
            </ng-container>
            <ng-container *ngSwitchDefault>{{ filterModel[filter].dateFrom | date: 'MM/dd/yyyy' }}</ng-container>
          </ng-container>
        </ng-container>

        <!-- text filter -->
        <ng-container *ngIf="filterModel[filter]?.filterType === 'text'">
          <ng-container [ngSwitch]="filterModel[filter]?.type">
            <ng-container *ngSwitchCase="'contains'"
              >Contains: {{ filterModel[filter]?.filter }}</ng-container
            >
            <ng-container *ngSwitchCase="'notContains'"
              >Not contains: {{ filterModel[filter]?.filter }}</ng-container
            >
            <ng-container *ngSwitchCase="'equals'"
              >Equals: {{ filterModel[filter]?.filter }}</ng-container
            >
            <ng-container *ngSwitchCase="'notEqual'"
              >Not equal: {{ filterModel[filter]?.filter }}</ng-container
            >
            <ng-container *ngSwitchCase="'startsWith'"
              >Starts with: {{ filterModel[filter]?.filter }}</ng-container
            >
            <ng-container *ngSwitchCase="'endsWith'"
              >Ends with: {{ filterModel[filter]?.filter }}</ng-container
            >
            <ng-container *ngSwitchCase="'notBetween'">

            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ filterModel[filter]?.filter }}
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- number filter -->
        <ng-container *ngIf="filterModel[filter]?.filterType === 'number'">
          <ng-container [ngSwitch]="filterModel[filter]?.type">
            <ng-container *ngSwitchCase="'equals'">
              Equals: {{ filterModel[filter]?.filter }}
            </ng-container>
            <ng-container *ngSwitchCase="'notEqual'">
              Not equal: {{ filterModel[filter]?.filter }}
            </ng-container>
            <ng-container *ngSwitchCase="'lessThan'">
              Less than: {{ filterModel[filter]?.filter }}
            </ng-container>
            <ng-container *ngSwitchCase="'lessThanOrEqual'">
              Less than or equals: {{ filterModel[filter]?.filter }}
            </ng-container>
            <ng-container *ngSwitchCase="'greaterThan'">
              Greater than: {{ filterModel[filter]?.filter }}
            </ng-container>
            <ng-container *ngSwitchCase="'greaterThanOrEqual'">
              Greater than or equals: {{ filterModel[filter]?.filter }}
            </ng-container>
            <ng-container *ngSwitchCase="'inRange'">
              In range: {{ filterModel[filter]?.filter }} - {{ filterModel[filter]?.filterTo }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ filterModel[filter]?.filter }}
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div> 